import axios from 'axios';

export type OverallFeedbackOption =
  | 'Good'
  | 'Not Good'
  | 'Needs Improvement'
  | "Don't Understand"
  | 'Excellent'
  | 'Other';

export interface VideoFeedbackSubmitPayload {
  video_id: string;
  cana_acceptable: 1 | 2 | 3 | 4 | 5;
  cana_accuracy: 1 | 2 | 3 | 4 | 5;
  cana_clarity: 1 | 2 | 3 | 4 | 5;
  cana_natural: 1 | 2 | 3 | 4 | 5;
  cana_overall: 1 | 2 | 3 | 4 | 5;
  overall_feedback: OverallFeedbackOption;
  feedback_comments?: string;
  would_recommend?: boolean;
}

export interface VideoFeedbackSubmitResponse {
  message: string;
}

const submitVideoFeedback = async (
  payload: VideoFeedbackSubmitPayload
): Promise<VideoFeedbackSubmitResponse> => {
  const baseUrl = process.env.REACT_APP_DEAFBIBLESOCIETY_API_V2;
  if (baseUrl === undefined) {
    throw new Error(`REACT_APP_DEAFBIBLESOCIETY_API_V2 is not set`);
  }

  const { data } = await axios.post<VideoFeedbackSubmitResponse>(
    `${baseUrl}/v1/deafbible/video-feedback/submit`,
    payload
  );

  return data;
};

export default submitVideoFeedback;
